var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseInput',{attrs:{"value":_vm.value,"name":_vm.id,"label":_vm.label,"rules":_vm.rules,"type":"text","autocomplete":false,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }